import { NgModule } from '@angular/core';

import { AvAvatarComponent } from './avatar';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [ CommonModule ],
  exports: [ AvAvatarComponent ],
  declarations: [ AvAvatarComponent ],
  providers: [],
})
export class AvAvatarModule { }
